import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Tipo'},
    {title: 'Código'},
    {title: 'Nombre'}
];

class CardCodeReferenceCreationModal extends Component {
    componentDidMount(): void {
        this.closeAction();
    }

    close = async () => {
        $('#cardCodeReferenceCreationModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#cardCodeReferenceCreationModal').on('hidden.bs.modal', function () {
            //console.log("cerrar groupCode");
            cleanData();
        });
    };


    render() {
        const {data, selectGroupCode} = this.props;
        //console.log("data groupCode", data);

        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="cardCodeReferenceCreationModal"></div>;
        }
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="cardCodeReferenceCreationModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Registros de coincidencias con base al código del SN</h4>
                                <button type="button" className="close" onClick={this.close} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"cardCodeReference"} action={''}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.close}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardCodeReferenceCreationModal;